<template>
  <div class="pull-left col-sm-1 mt-1">
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>
    export default {
        name: 'FlagChooser',
        data() {
            return {
                selected: 'en',
                options: [
                    { text: '🇧🇷', value: 'br' },
                    { text: '🇺🇸', value: 'en' }
                ]
            }
        }
    }
</script>

<style>
</style>